import script from "./goRinSyo0028.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0028.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0028.vue?vue&type=style&index=0&id=0b3b8176&lang=scss"

const __exports__ = script;

export default __exports__